<div class="mainContent">
<div class="pageHeader" i18n>Redlining</div>
  <mat-card>
    <mat-card-content class="mainDivision">
      <div class="actionItems">
      <div class="leftFilterItems">
        <mat-form-field class="filterField">
          <mat-label>Filter</mat-label>
          <input matInput (keyup)="filterRedlinings($event)">
        </mat-form-field>

        <div class="filterState"><strong i18n>Filter by Status :</strong> {{chosenStatus}}</div>          
      </div>

      <div class="rightIcons">
        <div class="filterBtn" *ngIf="access">
          <button mat-icon-button matTooltip="Filter" [matMenuTriggerFor]="menu">
            <mat-icon>filter_alt</mat-icon>
          </button> 
          <mat-menu #menu="matMenu">
            <button mat-menu-item *ngFor="let status of filterStatus" (click)="onFilter(status)">{{status}}</button>
          </mat-menu>
        </div> 

        <div class="deleteBtn" *ngIf="access">
          <button mat-icon-button i18n-matTooltip matTooltip="Delete" [disabled]="!deleteEnabled" (click)="onDelete()">
            <mat-icon>delete</mat-icon>
          </button> 
        </div>      
      </div>
    </div>

      <div class="contentContainer">
        <table mat-table [dataSource]="redDataSource" matSort>
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox (change)="$event ? toggleAllRows() : null"
              [checked]="selectionModel.hasValue() && isAllSelected()"
              [indeterminate]="selectionModel.hasValue() && !isAllSelected()">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox (click)="$event.stopPropagation()"
                (change)="$event ?selectionModel.toggle(row)||add(row,$event) : null"
                [checked]="selectionModel.isSelected(row)" *ngIf="access">
              </mat-checkbox>
            </td>
          </ng-container>
          
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> ID </th>
            <td mat-cell *matCellDef="let element"> {{element.id}} </td>
          </ng-container>

          <ng-container matColumnDef="objectType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> Object Type</th>
            <td mat-cell *matCellDef="let element"> {{element.objectType}} </td>
          </ng-container>

          <ng-container matColumnDef="objectId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> Object ID/Name </th>
            <td mat-cell *matCellDef="let element"> {{element.cSObjectId}} </td>
          </ng-container>

          <ng-container matColumnDef="subject">
            <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> Subject </th>
            <td mat-cell *matCellDef="let element"> {{element.subject}} </td>
          </ng-container>

          <ng-container matColumnDef="content">
            <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> Comment </th>
            <td mat-cell *matCellDef="let element"> {{element.content}} </td>
          </ng-container>

          <ng-container matColumnDef="user">
            <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> User </th>
            <td mat-cell *matCellDef="let element"> {{element.user}} </td>
          </ng-container>

          <ng-container matColumnDef="priorityText">
            <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> Priority </th>
            <td mat-cell *matCellDef="let element"> {{element.priorityText}} </td>
          </ng-container>

          <ng-container matColumnDef="createdDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> Created on </th>
            <td mat-cell *matCellDef="let element"> {{element.createdDate|date:'dd.MM.yyyy'}} </td>
          </ng-container>

          <ng-container matColumnDef="details">
            <th mat-header-cell *matHeaderCellDef i18n> Attachment </th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button color="black" *ngIf="element.attachmentsCount>0" (click)="loadAttachment(element.id)">
                <mat-icon class="mat-18">attachment</mat-icon>
              </button>
            </td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> Status </th>
            <td mat-cell *matCellDef="let element">
              <mat-select (selectionChange)="onStatusSelected(element)" [(value)]="element.status" style="width: 80px;">
                <mat-option *ngFor="let status of redLiningStatus" [value]="status">
                  {{status}}
                </mat-option>
              </mat-select>
            </td>
          </ng-container>        
          <tr mat-header-row *matHeaderRowDef="displayedRedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedRedColumns;" [ngClass]="{hovered: row.hovered}"
            (mouseover)="row.hovered = true" (mouseout)="row.hovered = false"></tr>
        </table>
      </div>
    </mat-card-content>
  </mat-card>
</div>
